const CartRoutes = {
  getCartData: 'buyer/cart',
  setCartData: 'buyer/addToCart',
  deleteCartData: 'buyer/deleteCart',
};

export default CartRoutes